/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import {hashHistory} from 'react-router';
import DmsTab from '../../components/dmsTab';
import {Button, Row, Col, Tabs, Rate, Popover, Radio, InputNumber, Select, Icon} from 'antd';

const TabPane = Tabs.TabPane;
const Option = Select.Option;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
import './product.css';
import {openNotice, config} from 'Utils';

const imgData = {
    'photoImg': require('../../assets/images/ic-dy-man03.png')
};
const star = {
    'star1': require('./star.png'),
    'star2': require('./star2.png'),
};
import {
    getProductDetails,
    getProductComment,
    getProductCommentCount,
    fetchSpecList,
    addFavoritesList,
    deleteFavoritesList,
    addShoppingCarList,
    LogisticsDetail
} from '../../service/product';
/*详情,本体附件,加入收藏夹,加入购物车接口*/
import moment from 'moment';
import zanWu from '../../assets/images/zanWu.png';

const customPrefix = '$radioVal_';

class ProductDetail extends React.Component {
    constructor(props) {
        super(props);
        this.userData = JSON.parse(window.localStorage.getItem('login_user_information') || '{}');
        this.channelData = window.sessionStorage.getItem('cur_channel') || '{}';
        this.state = {
            opts: ['产品详情'],
            selectImgIndex: 0,
            defaultActiveKey: 1,
            detailData: {},
            priceStock: {
                'price': 0,
                'suggestedPrice': 0,
                'stock': 0
            },
            channelCode: this.channelData.split('|')[1] || '',
            commentData: {},
            options1: [],
            bentiMsg: [],     //本体
            fujianMsg: [],    //附件
            mainSpec: [],
            slaveSpec: [],
            specification: '',
            LogisticData: [],     //物流点选择
            inventory: '',      //库存
            customerId: this.userData.thirdId,
            inputNumber: '',  //购买数量
            add: {
                // 规格
                specifications: ''
            },
            button_limits_end: {},
            // starClass: 'anticon-star-o' // 收藏星星样式
            isCollection: 0,
            itemCategory: ''  // 未查找到产品时的有效字段
        }
    }

    updateBigImg(index, qst) {
        /* 修改大图显示 */
        this.setState({selectImgIndex: index});
        this.setState({
            'detailData': {
                ...this.state.detailData,
                'bigImg': qst.fileCompressPath
            }
        });
    }

    onChange(e) {
        console.log(`${e.target.value}`);
    };

    tabClickFn(key) {
        /* 页签点击 */
        this.setState({
            'defaultActiveKey': key
        });
        if (key == 3) {
            /* 查看评论 */
            this.refreshProductComment();
        }
    }

    refreshProductComment() {
        let self = this;
        let id = self.props.params.productId;
        getProductCommentCount(id).then(result => {
            let resultData = result.data || {};
            let commentCount = 0;
            for (let field in resultData) {
                commentCount += resultData[field];
            }
            resultData.commentCount = commentCount;
            resultData.data = [];
            self.setState({
                commentData: resultData
            });
            if (result && result.code == 200) {
                getProductComment(id).then(resultList => {
                    if (resultList && resultList.code == 200) {
                        self.setState({
                            'commentData': {
                                ...self.state.commentData,
                                'data': resultList.data || []
                            }
                        });
                    } else {
                        openNotice('error', '评论获取失败', (resultList && resultList.message) ? resultList.message : '');
                    }
                });
            } else {
                openNotice('error', '评论获取失败', (result && result.message) ? result.message : '');
            }
        });
    }

    toEdit() {
        /* 跳转详情 */
        hashHistory.push('/product/add/' + this.state.detailData.id);
    };

    initData(dat) {
        let self = this;
        let id = this.props.params.productId;
        let _params = {id};
        if (dat) {
            _params = dat;
        }
        // console.log(_params);
        /* 产品详情接口 */
        getProductDetails({..._params}).then(function (result) {
            if (result && result.code == 200) {
                let detailData = result.data || {};
                detailData.bigImg = detailData.picUrls && detailData.picUrls.length > 0 ? detailData.picUrls[0].filePath : '';
                /*detailData.bigImg = detailData.picUrls == null ? '' : detailData.picUrls[0].filePath ;*/
                /*let jsonObject = JSON.parse(detailData.jsonObject || '[]');
                let selectArr = [];
                for (let spec of jsonObject) {
                  let selectData = [];
                  for (let data of spec.data) {
                    if (data.selected) {
                      data.selected = false;
                      selectData.push(data);
                    }
                  }
                  if (selectData.length > 0) {
                    selectArr.push({
                      'text': spec.text,
                      'code': spec.code,
                      'data': selectData
                    });
                  }
                }
                detailData.jsonObject = selectArr;
                detailData.categoryText = (detailData.categoryText || '').replace(/,/g, '-');*/
                if (!detailData.id) {
                    detailData.name = '未匹配到相应产品';
                    detailData.itemNum = '';
                    detailData.unit = '';
                    detailData.minPackageQuantity = '';
                    detailData.packageQuantity = '';
                    detailData.sortOrder = '';
                    detailData.proBigName = '';
                    detailData.stockType = '';
                    detailData.minOrderQuantity = '';
                    detailData.proLine = '';
                    detailData.price = 0;
                    self.setState({
                        detailData: detailData,
                        itemCategory: detailData.itemCategory,
                        hasDetail: false
                    });
                } else {
                    self.setState({
                        'detailData': detailData,
                        'bentiMsg': detailData.categoryTypeVo.bentiMsg || [], /* 本体 */
                        'fujianMsg': detailData.categoryTypeVo.fujianMsg || [], /* 附件 */
                        'isCollection': detailData.isCollection, /* 是否收藏 0未收藏 1已收藏 */
                        'hasDetail': true
                    }, () => {
                        // console.log(self.state.bentiMsg);
                        /* 默认选中项 */
                        let msgList = self.state.bentiMsg
                            , _obj = {}
                        ;
                        msgList.forEach((d, i) => {
                            // _obj[customPrefix + d.propertyNum] = d.propertyDesc;
                            _obj[customPrefix + d.propertyName] = d.propertyDesc;
                        });
                        (detailData.categoryTypeVo.fujianMsg || []).forEach((d, i) => {
                            // _obj[customPrefix + d.propertyNum] = d.propertyDesc;
                            _obj[customPrefix + d.propertyName] = d.propertyDesc;
                        });
                        self.setState({..._obj});
                    });
                    self.setState({
                        'priceStock': {
                            'price': detailData.showPrice,
                            'suggestedPrice': detailData.suggestedPrice,
                            'stock': (detailData.inventory || 0) + ' ' + detailData.unitText
                        }
                    });
                    /* 首次进入请求以下接口 */
                    if (!dat) {
                        self.refreshProductComment();
                        /*本体附件*/
                        self.getSpecList(detailData.categoryId);
                        /*物流点*/
                        self.getLogisticsDetail(detailData.itemNum);
                    }
                }
            } else {
                openNotice('error', '数据获取失败', (result && result.message) ? result.message : '');
            }
        });
    };

    componentDidMount() {
        this.initData();
    }

    /*物流点*/
    getLogisticsDetail = (itemNum) => {
        const {customerId} = this.state;
        LogisticsDetail({customerId: customerId, itemNum: itemNum}).then(res => {
            this.setState({
                LogisticData: res.data,
            })
        })
    };
    /*物流点选中*/
    logisticChange = (value) => {
        // console.log('Selected logistic is: ' + value);
        this.setState({
            inventory: value
        });
    };

    /*本体附件接口*/
    getSpecList = (categoryId) => {
        fetchSpecList(categoryId).then(result => {
            if (result.status && result.code == 200) {
                var arr1 = [], // 本体
                    arr2 = []; // 附件

                result.data.bentiMsg.forEach(ele => {
                    arr1.push(ele);
                });
                result.data.fujianMsg.forEach(ele => {
                    arr2.push(ele);
                });
                // console.log(arr1);
                this.setState({
                    mainSpec: arr1,
                    slaveSpec: arr2
                });
            } else {
                openNotice('error', '获取规格失败', result.message || '');
            }
        });
    };

    /*本体附件选中显示*/
    radioOnChange = (e) => {
        let self = this;
        let _obj = {
            bentiMsg: this.state.bentiMsg,
            fujianMsg: this.state.fujianMsg
        };
        // console.log('radio checked', e.target.value);
        // console.log(this.state.bentiMsg);
        // console.log(this.state.fujianMsg);
        // console.log(e);
        this.setState({[customPrefix + e.target.propertyName]: e.target.value}, () => {
            var arr = [];
            // console.log(this.state);
            for (var name in this.state) {
                if (name.indexOf(customPrefix) > -1) {
                    arr.push(this.state[name]);
                }
            }
            self.setState({add: {...this.state.add, specifications: arr.toString()}});
            let tag = e.target.tag;
            if (tag == 'ben') {
                let _list = self.state.bentiMsg
                    , _defaultList = self.state.mainSpec
                    , _arr = []
                ;
                for (let i = 0; i < _list.length; i++) {
                    _list[i].checked = false;
                    if (_list[i].propertyName == e.target.propertyName) {
                        _list[i].propertyDesc = e.target.value;
                        _list[i].checked = true;
                        // break;
                    }
                }
                _defaultList.forEach((d, i) => {
                    for (let i = 0; i < _list.length; i++) {
                        if (d.propertyName == _list[i].propertyName) {
                            _arr.push(_list[i]);
                            break;
                        }
                    }
                });
                // console.log(self.state.bentiMsg);
                _obj.bentiMsg = _arr;
            } else {
                // _obj.fujianMsg = _list;
            }
            self.initData(_obj);
        });
    };

    /* 加入&取消收藏夹 */
    addfFavorites(event) {
        let Id = this.props.params.productId;
        let _arr = [
            {productId: Id}
        ];
        let func = addFavoritesList
            , isCollection = 0
            , _text = '加入'
        ;
        if (this.state.isCollection) {
            func = deleteFavoritesList;
            isCollection = 0;
            _text = '取消';
        } else {
            func = addFavoritesList;
            isCollection = 1;
            _text = '加入';
        }
        eval(func)(_arr).then(result => {
            if (result && result.code == 200) {
                openNotice('success', _text + '收藏成功', '');
                this.setState({
                    isCollection
                })
            } else {
                openNotice('error', _text + '收藏失败', (result && result.message) ? result.message : '');
            }
        });
        // addFavoritesList(_arr).then(function (result) {
        //   if (result && result.code == 200) {
        //     openNotice('success', '加入收藏夹成功', '');
        //   } else {
        //     openNotice('error', '加入收藏夹失败', (result && result.message) ? result.message : '');
        //   }
        // });
    }

    /*数量加减*/
    changeNumber(value) {
        // console.log('changed', value);
        this.setState({
            inputNumber: value,
        });
    }

    /*加入购物车*/
    addShoppingCar() {
        // console.log(this.state.inputNumber);
        if (!this.state.hasDetail) {
            openNotice('error', '请选择有效产品');
            return;
        }
        let Id = this.props.params.productId;
        let _arr = [
            {
                productId: Id,
                channelCode: this.state.channelCode,
                count: this.state.inputNumber || 1,
            }
        ];
        addShoppingCarList(_arr).then(function (result) {
            if (result && result.code == 200) {
                openNotice('success', '加入购物车成功', '');
            } else {
                openNotice('error', '加入购物车失败', (result && result.message) ? result.message : '');
            }
        });
    };

    backHandle() {
        window.history.go(-1);
    }

    componentWillMount() {
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end")),
        })
    };

    openImg(path) {
        window.open(path);
    }

    render() {
        const {
            star, opts, detailData, selectImgIndex, defaultActiveKey, commentData, priceStock, LogisticData
            , button_limits_end, starClass, isCollection, hasDetail, itemCategory,
        } = this.state;
        let self = this;
        let imgHtml = (detailData.picUrls || []).map(function (qst, key) {
            return <img className={selectImgIndex == key ? 'selected' : ''}
                        onMouseOver={self.updateBigImg.bind(self, key, qst)} alt=""
                        src={config.server + qst.fileCompressPath}
                        key={key}/>
        });
        let commentHtml = (commentData.data || []).map(function (qst, key) {
            var imgH = (qst.picFileList || []).map(function (q, k) {
                if (!q) {
                    return '';
                }
                return <img style={{cursor: 'pointer'}}
                            onClick={self.openImg.bind(self, config.server + q.fileCompressPath)}
                            key={k} alt="" src={config.server + q.fileCompressPath}/>;
            });
            return <li key={key}>
                <img alt=""
                     src={qst.isAnonymity === 1 ? imgData['photoImg'] : (qst.picUrl ? (config.server + qst.picUrl) : imgData['photoImg'])}/>
                <span className="na">{qst.isAnonymity === 1 ? '匿名用户' : qst.evaluator}</span>
                <div>
                    <p className="na">{qst.evaluation || '好评！'}</p>
                    {imgH}
                    <p><span>{qst.createdDate}</span><span>{qst.spec}</span></p>
                </div>
            </li>
        });
        let informationContent = (detailData.fileUrls || []).map(function (qst, key) {
            return <div key={key} style={{margin: '4px'}}>
                <a href={`${config.server}/api/v1/dms/commonAttachUpload/getFileDown?id=${qst.id}`}>
                    {qst.fileName}
                </a>
            </div>
        });

        const content = (
            <div style={{width: 320}}>
                <Row>
                    <Col span={12}>
                        <label>日期</label>
                    </Col>
                    <Col span={12}>
                        <label>价格</label>
                    </Col>
                    <Col span={12} style={{marginTop: 6}}>
                        <label>{moment(detailData.createdDate).format('YYYY-MM-DD HH:mm:ss')}</label>
                    </Col>
                    <Col span={12} style={{marginTop: 6}}>
                        <label>¥{priceStock.price}</label>
                    </Col>
                </Row>
            </div>
        );
        const iconLayout = {
            width: '32px',
            height: '32px',
            float: 'right',
            paddingRight: '10px',
            cursor: 'pointer',
            fontSize: '32px',
            color: '#65aca6',
        };
        // console.log(itemCategory.bentiMsg);
        const radioLayout = {marginLeft: 10};
        const radioButtonLayout = {marginRight: 10, marginBottom: 10};
        const bentiMsg = itemCategory.bentiMsg || [];
        var mainRenderer = (this.state.mainSpec || []).map((ele, index) => {
            var radioOptionsRenderer = (ele.propertyDescName || []).map((e, i) => {
                let _className = '';
                if (bentiMsg.length) {
                    for (let i = 0; i < bentiMsg.length; i++) {
                        if (ele.propertyName == bentiMsg[i].propertyName) {
                            let _str = ',' + bentiMsg[i].propertyDescName + ',';
                            _className = _str.indexOf(',' + e + ',') != -1 ? '' : 'grayBtn';
                            break;
                        }
                    }
                }
                return <RadioButton
                    style={radioButtonLayout}
                    key={i}
                    tag="ben"
                    propertyName={ele.propertyName}
                    value={e}
                    className={_className}
                >{e}
                </RadioButton>
            });
            if (index > 0) {
                return (
                    <div key={index}
                         className="dms-spec-radio-group"
                         style={{marginBottom: index === this.state.mainSpec.length - 1 ? 0 : 10}}>
                        <hr style={{marginBottom: '14px', height: '1px'}}/>
                        <div style={{fontWeight: 'bold'}}><Icon type="logout"
                                                                style={{paddingLeft: '1px'}}/>{ele.propertyName}</div>
                        <RadioGroup value={this.state[customPrefix + ele.propertyName]} style={radioLayout}
                                    onChange={this.radioOnChange}>
                            {radioOptionsRenderer}
                        </RadioGroup>
                    </div>
                )
            }
            else {
                return (
                    <div key={index}
                         className="dms-spec-radio-group"
                         style={{marginBottom: index === this.state.mainSpec.length - 1 ? 0 : 10}}>
                        <div style={{fontWeight: 'bold'}}><Icon type="logout"
                                                                style={{paddingLeft: '1px'}}/>{ele.propertyName}
                        </div>
                        <RadioGroup value={this.state[customPrefix + ele.propertyName]} style={radioLayout}
                                    onChange={this.radioOnChange}>
                            {radioOptionsRenderer}
                        </RadioGroup>
                    </div>
                )
            }
        });

        var slaveRenderer = (this.state.slaveSpec || []).map((ele, index) => {
            var radioOptionsRenderer = (ele.propertyDescName || []).map((e, i) => {
                return <RadioButton style={radioButtonLayout} key={i} id={ele.id} tag="attach"
                                    propertyName={ele.propertyName} value={e}>{e}</RadioButton>
            });
            if (index > 0) {
                return (
                    <div key={index}
                         className="dms-spec-radio-group"
                         style={{marginBottom: index === this.state.slaveSpec.length - 1 ? 0 : 10}}>
                        <hr style={{marginBottom: '14px', height: '1px'}}/>
                        <div style={{fontWeight: 'bold'}}><Icon type="logout"
                                                                style={{paddingLeft: '1px'}}/>{ele.propertyName}</div>
                        <RadioGroup value={this.state[customPrefix + ele.propertyName]} name={'group' + ele.id}
                                    style={radioLayout} key={index}
                                    onChange={this.radioOnChange}>
                            {radioOptionsRenderer}
                        </RadioGroup>
                    </div>
                )
            } else {
                return (
                    <div key={index}
                         className="dms-spec-radio-group"
                         style={{marginBottom: index === this.state.slaveSpec.length - 1 ? 0 : 10}}>
                        <div style={{fontWeight: 'bold'}}><Icon type="logout"
                                                                style={{paddingLeft: '1px'}}/>{ele.propertyName}</div>
                        <RadioGroup value={this.state[customPrefix + ele.propertyName]} name={'group' + ele.id}
                                    style={radioLayout} key={index}
                                    onChange={this.radioOnChange}>
                            {radioOptionsRenderer}
                        </RadioGroup>
                    </div>
                )
            }
        });
        const productLineName = {
            '01': '元器件',
            '02': '电工',
            '03': '电表',
            '04': '变频器',
            '05': '天e',
            '06': 'TG精品'
        };
        return <div>
            <DmsTab options={opts} defaultKey={0}>
                {button_limits_end.product_detail_01 && <Button onClick={this.toEdit.bind(this)}>编辑</Button>}
                <Button onClick={this.backHandle.bind(this)}>返回</Button>
            </DmsTab>
            <div className="dms-table-box" style={{padding: 0}}>
                <div style={{position: 'relative', padding: '12px 0 12px 372px'}}>
                    <div className="detail_img">
                        <img src={detailData.bigImg ? config.server + (detailData.bigImg) : zanWu}
                             alt={''}
                             style={{
                                 width: detailData.bigImg ? '100%' : '50%',
                                 height: detailData.bigImg ? '100%' : '50%',
                                 marginLeft: detailData.bigImg ? '' : '20%'
                             }}/>
                        <div className="small_scroll">
                            {imgHtml}
                        </div>
                    </div>
                    <div className="detail_field">
                        <div className="na">{detailData.name}</div>
                        <div className="pri">
                            <p className="d">牌价<span>¥{hasDetail ? priceStock.price : 0}</span></p>
                            {
                                hasDetail ? (
                                    <a>
                                        <Popover placement="top" content={content}>
                                            <span>历史价格 <Icon type="exclamation-circle-o" /></span>
                                        </Popover>
                                    </a>
                                ) : ''
                            }
                            {
                                hasDetail ? (
                                    <div className="ri">
                                        <span>{detailData.viewCount || 0}</span><br/>
                                        <span>浏览量</span>
                                    </div>
                                ) : ''
                            }
                        </div>
                        <div className="de">
                            <ul className="left">
                                <li>
                                    <label>物料编码</label>
                                    <p>{detailData.itemNum}</p>
                                </li>
                                <li>
                                    <label>单位</label>
                                    <p>{detailData.unit}</p>
                                </li>
                                <li>
                                    <label>最小装箱数</label>
                                    <p>{detailData.minPackageQuantity}</p>
                                </li>
                                <li>
                                    <label>装箱数</label>
                                    <p>{detailData.packageQuantity}</p>
                                </li>
                                {/* <li>
                                    <label>每小盒数量</label>
                                    <p>{detailData.sortOrder}</p>
                                </li> */}
                            </ul>
                            <ul className="right">
                                <li>
                                    <label>物料大类</label>
                                    <p>{detailData.proBigName}</p>
                                </li>
                                <li>
                                    <label>库存类型</label>
                                    <p>{detailData.stockType}</p>
                                </li>
                                <li>
                                    <label>最小起订量</label>
                                    <p>{detailData.minOrderQuantity}</p>
                                </li>
                                <li>
                                    <label>产品线</label>
                                    <p>{productLineName[detailData.proLine]}</p>
                                </li>
                            </ul>
                        </div>
                        <section className="code-box-meta markdown">
                            <div className="code-box-title">选型</div>
                            <Tabs className="spec-tabs" type="card">
                                <TabPane tab="本体" key="1">
                                    {
                                        mainRenderer
                                    }
                                </TabPane>
                                <TabPane tab="附件" key="2">
                                    {
                                        slaveRenderer
                                    }
                                </TabPane>
                            </Tabs>
                        </section>
                        <div className="shopping-cart">
                            <p style={{marginBottom: '10px'}}>已选：{this.state.add.specifications}</p>
                            <div style={{marginBottom: '10px'}}>
                                <span>库存：{this.state.inventory || 0}</span>
                                <span style={{marginLeft: 100}}>物流点：
                  <span>
                    <Select defaultValue="请选择物流点" style={{width: 200}} onChange={this.logisticChange}>
                      {(LogisticData || []).map(function (ele, itm) {
                          return <Option key={itm} value={ele.anhand + ''}>{ele.orgName}</Option>;
                      })}
                    </Select>
                  </span>
                </span>
                            </div>
                            <div>购买数量&nbsp;&nbsp;
                                <InputNumber min={1} max={999999} defaultValue={1}
                                             onChange={this.changeNumber.bind(this)}/>
                                {
                                    button_limits_end.product_detail_03 &&
                                    <Button size="large" type="primary" onClick={this.addShoppingCar.bind(this)} style={{
                                        bottom: '2px',
                                        float: 'right'
                                    }}>加入购物车</Button>
                                }&nbsp;&nbsp;
                                {
                                    // button_limits_end.product_detail_02 && <img onClick={this.addfFavorites.bind(this)}  style={iconLayout} src={require('./star.png')} />
                                    // button_limits_end.product_detail_02 && <span onClick={this.addfFavorites.bind(this)}  style={iconLayout} className={'anticon ' + starClass} ></span>
                                    button_limits_end.product_detail_02 &&
                                    <span onClick={this.addfFavorites.bind(this)} style={iconLayout}
                                          className={'anticon ' + `${isCollection ? 'anticon-star' : 'anticon-star-o'}`}></span>
                                }&nbsp;&nbsp;
                            </div>
                        </div>
                    </div>
                </div>
                <div className="detail_other">
                    <Tabs className="tab_individual my-ant-tabs" defaultActiveKey={defaultActiveKey + ''} onChange={this.tabClickFn.bind(this)}>
                        <TabPane tab="图文详情" key="1">
                            <div dangerouslySetInnerHTML={{__html: detailData.graphicDetails}}></div>
                        </TabPane>
                        <TabPane tab="产品参数" key="2">
                            <div dangerouslySetInnerHTML={{__html: detailData.parameter}}></div>
                        </TabPane>
                        <TabPane tab={'累计评价（' + (commentData.commentCount || 0) + '）'} key="3">
                            <div className="product_comment">
                                <div className="star">
                                    <span>评价</span>
                                    <ul>
                                        <li>
                                            <Rate disabled defaultValue={5}/><span>{commentData.fiveCount || 0}</span>
                                        </li>
                                        <li>
                                            <Rate disabled defaultValue={4}/><span>{commentData.fourCount || 0}</span>
                                        </li>
                                        <li>
                                            <Rate disabled defaultValue={3}/><span>{commentData.threeCount || 0}</span>
                                        </li>
                                        <li>
                                            <Rate disabled defaultValue={2}/><span>{commentData.twoCount || 0}</span>
                                        </li>
                                        <li>
                                            <Rate disabled defaultValue={1}/><span>{commentData.oneCount || 0}</span>
                                        </li>
                                    </ul>
                                </div>
                                <div className="list">
                                    <ul>
                                        {commentHtml}
                                    </ul>
                                </div>
                            </div>
                        </TabPane>
                        <TabPane tab="产品资料" key="4">
                            <div style={{padding: '12px', background: '#fff'}}>
                                <p>附件：</p>
                                {informationContent}
                            </div>
                        </TabPane>
                    </Tabs>
                    {/*<div className="line-b"></div>*/}
                    {/*<div className="line-c" style={{left: ((defaultActiveKey - 1) * 150 + 10) + 'px'}}></div>*/}
                </div>
            </div>
        </div>
    }
}
;
export default ProductDetail;



// WEBPACK FOOTER //
// ./src/routes/product/detail.js